import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DistributionTestSummaryItem from './DistributionTestSummaryItem';
import { injectIntl } from 'react-intl';
import FormattedCurrencyInput from '../shared/FormattedCurrencyInput';
import { Button, Icon } from 'semantic-ui-react';

import EditDistributionForm from './EditDistributionForm';
import { MotifButton, MotifToggleSwitch, MotifModal } from '@ey-xd/motif-react';
import { NumberField } from '../shared/formFields';
import * as formValidators from '../../scripts/formValidators';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';

const DistributionTestSummary = ({
  distributionTestSummary,
  showDetails,
  handleShowDetails,
  distributionTaxableIncome,
  distributionTaxableIncomeValue,
  distributionDetails,
  totalValue,
  setTaxableIncome,
  updateInputValue,
  taxableIncomeFromForm,
  showForm,
  handleCloseForm,
  handleNewButtonClick,
  handleSubmit,
  formPurpose,
  selectedDistribution,
  canEdit,
  isChecklist,
  handleDismissErrorMessage,
}) => {
  // Reset the ref in NumberField component
  const [isUpdatedDefault, setIsUpdatedDefault] = useState(false);
  const initialValues = {
    fairMarketValue: '0.00',
    value: '0.00',
  };

  if (!isChecklist) {
    isChecklist = false;
  }

  const handleSetTaxableIncome = () => {
    setIsUpdatedDefault(true);
    const valueToSend =
      taxableIncomeFromForm !== undefined &&
      taxableIncomeFromForm !== '' &&
      taxableIncomeFromForm !== null
        ? taxableIncomeFromForm
        : distributionTaxableIncomeValue;
    setTaxableIncome(valueToSend);
  };

  const handleUpdateInputValue = (event) => {
    setIsUpdatedDefault(false);
    updateInputValue(event);
  };

  return (
    <div>
      <div className="rtable">
        <h2 className="pageheader">
          Distribution Test Summary {canEdit ? '' : '- Testing Closed'}
        </h2>
      </div>
      <div className="row container-fluid">
        <section className="inline col">
          <div className="row">
            <div className="testl col-md-6">
              {distributionTestSummary.tests.map((test) => (
                <DistributionTestSummaryItem
                  key={test.title}
                  test={test}
                  totalItems={distributionTestSummary.tests.length}
                />
              ))}
            </div>
            <div className="testm col-md-6">
              <div className="field">
                <NumberField
                  value={totalValue}
                  name="distributionsSummary"
                  label="Dividends (Summary from Inputs)"
                  placeholder="0"
                  disabled={true}
                  maxLength="21"
                />
              </div>
              <div className={`field ${isChecklist ? 'mt-2' : ''} `}>
                <NumberField
                  value={distributionTaxableIncomeValue || 0}
                  name="taxableIncome"
                  label="REIT Taxable Income"
                  placeholder="0"
                  allowDecimal={true}
                  allowNegativeValues={true}
                  allowLessThanZero={true}
                  disabled={!canEdit}
                  maxLength="16"
                  validate={[
                    formValidators.number,
                    formValidators.maxValueDecimal,
                  ]}
                  onChange={(event) => handleUpdateInputValue(event)}
                  isUpdatedDefault={isUpdatedDefault}
                />
              </div>
              {(!isChecklist && (
                <div>
                  <MotifButton
                    variant="primary"
                    type="button"
                    onClick={handleSetTaxableIncome}
                    disabled={!canEdit}
                  >
                    Update Results
                  </MotifButton>
                </div>
              )) ||
                null}
            </div>
          </div>
        </section>
      </div>
      {(!isChecklist && (
        <div className="row" style={{ marginTop: '45px', marginBottom: '5px' }}>
          <div className="col-md-10">
            <span className="left mr-3">Display Distribution Details:</span>
            <div
              className="switch-box"
              style={{
                display: 'inline-block',
                position: 'relative',
                textAlign: 'left',
              }}
            >
              <MotifToggleSwitch
                aria-label="Display Distribution Details toogle"
                name="switchOff"
                id="switchOff"
                onChange={handleShowDetails}
                checked={showDetails}
              />
            </div>
          </div>

          <div className="col-md-2">
            {showDetails ? (
              <MotifButton
                variant="secondary"
                className="right"
                type="button"
                onClick={handleNewButtonClick}
                disabled={!canEdit}
              >
                Add Distribution
              </MotifButton>
            ) : null}
          </div>
        </div>
      )) ||
        null}

      <MotifModal
        show={showForm}
        size="lg"
        variant="alt"
        area-label={
          formPurpose === 'ADD'
            ? 'Add Distribution'
            : formPurpose === 'EDIT'
              ? 'Edit Distribution'
              : 'Delete Distribution'
        }
        onClose={handleCloseForm}
      >
        <EditDistributionForm
          onSubmit={handleSubmit}
          handleCloseForm={handleCloseForm}
          initialValues={selectedDistribution}
          formPurpose={formPurpose}
          handleDismissErrorMessage={handleDismissErrorMessage}
        />
      </MotifModal>
    </div>
  );
};

DistributionTestSummary.propTypes = {
  distributionTestSummary: PropTypes.shape({
    tests: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        isPassing: PropTypes.bool,
        percent: PropTypes.number,
      })
    ),
    newAccounts: PropTypes.number,
    deletedAccounts: PropTypes.number,
  }).isRequired,
  distributionDetails: PropTypes.array,
  distributionTaxableIncome: PropTypes.shape({
    reportPeriod: PropTypes.string,
    reportPeriodID: PropTypes.number,
    distributionREITTaxableIncomeAmount: PropTypes.number,
    distributionDividendsSum: PropTypes.number,
  }),
  showDetails: PropTypes.bool,
  handleShowDetails: PropTypes.func,
  totalValue: PropTypes.number,
  setTaxableIncome: PropTypes.func,
  updateInputValue: PropTypes.func,
  taxableIncomeFromForm: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  showForm: PropTypes.bool,
  handleCloseForm: PropTypes.func,
  handleNewButtonClick: PropTypes.func,
  handleSubmit: PropTypes.func,
  formPurpose: PropTypes.string,
  selectedDistribution: PropTypes.object,
  canEdit: PropTypes.bool,
  isChecklist: PropTypes.bool,
  handleDismissErrorMessage: PropTypes.func,
};

const selector = formValueSelector('distributionTaxableIncomeForm');

function mapStateToProps(state) {
  return {
    taxableIncomeFromForm: selector(state, 'taxableIncome'),
  };
}

// export default DistributionTestSummary;
export default connect(mapStateToProps)(
  reduxForm({
    form: 'distributionTaxableIncomeForm',
    enableReinitialize: true,
  })(DistributionTestSummary)
);
